module.exports = __webpack_public_path__ + "img/1_021.471b58e9.jpg";